import React from 'react';
import { PropTypes as PT } from 'prop-types';
import SVG from 'react-inlinesvg';
import cancelIcon from '@lifesize/ux-assets/vectors/svgIcons/cancel.svg';
import classes from './Pill.module.scss';

export class Pill extends React.PureComponent {
  constructor(props) {
    super(props);

    this.remove = this.onRemove.bind(this);
    this.mouseDown = this.handleMouseDown.bind(this);
    this.touchEndRemove = this.handleTouchEndRemove.bind(this);
    this.touchMove = this.handleTouchMove.bind(this);
    this.touchStart = this.handleTouchStart.bind(this);
  }

  onRemove(event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onRemove(this.props.value);
  }

  handleMouseDown(event) {
    if (this.props.onClick) {
      event.stopPropagation();
      this.props.onClick(this.props.value, event);
      return;
    }
    if (this.props.value.href) {
      event.stopPropagation();
    }
  }

  handleTouchEndRemove(event) {
    // Check if the view is being dragged, In this case
    // we don't want to fire the click event (because the user only wants to scroll)
    if (this.dragging) return;

    // Fire the mouse events
    this.onRemove(event);
  }

  handleTouchMove() {
    // Set a flag that the view is being dragged
    this.dragging = true;
  }

  handleTouchStart() {
    // Set a flag that the view is not being dragged
    this.dragging = false;
  }

  renderRemoveIcon() {
    if (this.props.disabled || !this.props.onRemove) {
      return (<span />);
    }
    return (
      <span
        className={classes.button}
        aria-hidden="true"
        onMouseDown={this.remove}
        onTouchEnd={this.touchEndRemove}
        onTouchStart={this.touchStart}
        onTouchMove={this.touchMove}
        data-testid="pill-remove"
      >
        <SVG src={cancelIcon} data-testid="cancelIcon" />
      </span>
    );
  }

  renderLabel() {
    return (this.props.onClick || this.props.value.href)
      ? (
        <a
          className={classes.label}
          href={this.props.value.href}
          target={this.props.value.target}
          onMouseDown={this.mouseDown}
          onTouchEnd={this.mouseDown}
        >
          {this.props.children}
        </a>
      )
      : (
        <div className={classes.label} role="option" aria-selected="true" id={this.props.id}>
          {this.props.children}
        </div>
      );
  }

  render() {
    return (
      <div
        className={`pill ${classes.container}`}
        style={this.props.value.style}
        title={this.props.value.title}
      >
        {this.renderLabel()}
        {this.renderRemoveIcon()}
      </div>
    );
  }
}

Pill.propTypes = {
  children: PT.node,
  disabled: PT.bool, // disabled prop passed to ReactSelect
  id: PT.string, // Unique id for the value - used for aria
  onClick: PT.func, // method to handle click on value label
  onRemove: PT.func, // method to handle removal of the value
  value: PT.object.isRequired, // the option object for this value
};

export default Pill;
